import { ReactNode } from "react";
import { Col } from "react-bootstrap";

interface PaymentLocationFormFieldProps {
  label: ReactNode;
  children: ReactNode;
  required?: boolean;
}

export default function PaymentLocationFormField({ label, children, required }: PaymentLocationFormFieldProps) {
  return (
    <div className="input-row">
      <Col lg={5} className="p-0">
        <div className={`font-b1 font-weight-bold ${required ? "required" : ""}`}>{label}</div>
      </Col>
      <Col lg={7} className="p-0">
        {children}
      </Col>
    </div>
  );
}

PaymentLocationFormField.defaultProps = {
  required: false,
};
